import { render, staticRenderFns } from "./WordPressDialog.vue?vue&type=template&id=98443042&"
import script from "./WordPressDialog.vue?vue&type=script&lang=js&"
export * from "./WordPressDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports